import React, { Component } from 'react';
import * as THREE from "three";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls";

const style = {
    height: "60vh"
};

export class ThreeWindow extends Component {
    static displayName = ThreeWindow.name;

    componentDidMount() {
        this.sceneSetup();
        this.addCustomSceneObjects();
        this.startAnimationLoop();
        window.addEventListener("resize", this.handleWindowResize);
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.handleWindowResize);
        window.cancelAnimationFrame(this.requestID);
        if (this.controls) this.controls.dispose();
        if (this.points) {
            this.points.geometry?.dispose();
            this.points.material?.dispose();
        }
        if (this.renderer) {
            this.renderer.dispose();
            this.el?.removeChild(this.renderer.domElement);
        }
    }

    sceneSetup = () => {
        const width = this.el.clientWidth;
        const height = this.el.clientHeight;

        this.scene = new THREE.Scene();

        this.camera = new THREE.PerspectiveCamera(27, width / height, 5, 35000);
        this.camera.position.set(27500, 0, 0);

        this.renderer = new THREE.WebGLRenderer({ antialias: true });
        this.renderer.setSize(width, height);
        this.renderer.setPixelRatio(window.devicePixelRatio);
        this.renderer.outputColorSpace = THREE.SRGBColorSpace; // r180+

        this.el.appendChild(this.renderer.domElement);

        this.controls = new OrbitControls(this.camera, this.renderer.domElement);
    };

    addCustomSceneObjects = () => {
        const positions = [];
        const colors = [];
        const color = new THREE.Color();

        const pointcloud = this.props.threeWindowPointsData || [];
        for (let i = 0; i < pointcloud.length; i++) {
            const x = pointcloud[i].x;
            const y = pointcloud[i].y;
            const z = pointcloud[i].z;

            if (x !== 0 && y !== 0 && z !== 0) {
                positions.push(x, y, z);

                // Normalize to [0,1] for three.js colors
                const rComp = Math.max(0, Math.min(255, pointcloud[i].r || 0)) / 255;
                const gComp = 1.0; // 255/255
                const bComp = 0.0;

                color.setRGB(rComp, gComp, bComp);
                colors.push(color.r, color.g, color.b);
            }
        }

        const geometry = new THREE.BufferGeometry();
        geometry.setAttribute('position', new THREE.Float32BufferAttribute(positions, 3));
        geometry.setAttribute('color', new THREE.Float32BufferAttribute(colors, 3));
        geometry.computeBoundingSphere();

        const material = new THREE.PointsMaterial({
            size: 10,
            vertexColors: true, // three r180+ (replaces THREE.VertexColors)
        });

        this.points = new THREE.Points(geometry, material);
        this.scene.add(this.points);
    };

    startAnimationLoop = () => {
        if (!this.renderer) return;
        this.renderer.render(this.scene, this.camera);
        this.requestID = window.requestAnimationFrame(this.startAnimationLoop);
    };

    handleWindowResize = () => {
        if (!this.renderer || !this.camera) return;
        const width = this.el.clientWidth;
        const height = this.el.clientHeight;

        this.renderer.setSize(width, height);
        this.camera.aspect = width / height;
        this.camera.updateProjectionMatrix();
    };

    render() {
        return <div style={style} ref={ref => (this.el = ref)} />;
    }
}